import fetchFactory from '../../../utils/fetchFactory'
import {configEnum} from '../../../enums/fetchFactoryEnum'

export const getCGU = (lang: string, portal: string) => fetchFactory(`/api/${portal}/information/getCgu?language=${lang}`,
    {
        method: configEnum.post,
    })